import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { api } from "@/lib/api";

const COLORS = {
  Siaga: "#2E8B57",
  Penggalang: "#C0392B",
  Penegak: "#E5A93C",
  Pandega: "#6B5B4E",
  "Anggota Dewasa": "#4A2E2B",
};

export function GolonganPie() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/public/stats").then(({ data: d }) => setData(d.per_golongan)).catch(() => {});
  }, []);
  if (!data) return null;
  const total = data.reduce((s, d) => s + d.value, 0);
  const pct = (v) => (total ? `${((v / total) * 100).toFixed(1).replace(".", ",")}%` : "0%");

  return (
    <motion.div data-testid="hero-golongan-pie" initial={{ opacity: 0, y: -16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }}
      className="mb-6 bg-white/85 backdrop-blur rounded-2xl border border-[#E5DFD7] shadow-sm p-4 flex items-center gap-4">
      <div className="h-32 w-32 shrink-0 relative">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" innerRadius={38} outerRadius={60} paddingAngle={2} stroke="none"
              isAnimationActive animationDuration={1200}>
              {data.map((d) => <Cell key={d.name} fill={COLORS[d.name]} />)}
            </Pie>
            <Tooltip formatter={(v, n) => [pct(v), n]} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <div className="font-display text-lg font-extrabold text-[#1F1917] leading-none">100%</div>
          <div className="text-[9px] uppercase tracking-widest font-bold text-[#8C827A]">Jenjang</div>
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-widest font-bold text-[#B85C38] mb-2">Pramuka per Jenjang</div>
        <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5">
          {data.map((d) => (
            <li key={d.name} data-testid={`pie-legend-${d.name.toLowerCase().replace(/\s+/g, "-")}`} className="flex items-center gap-2 min-w-0">
              <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: COLORS[d.name] }} />
              <span className="text-xs text-[#4A423F] truncate">{d.name}</span>
              <span className="ml-auto text-xs font-bold text-[#1F1917] tabular-nums">{pct(d.value)}</span>
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
}
